import { api } from './client';

/**
 * Series Notes / Dossiers — GET/PUT projects.series_snapshots.
 * people | world | custom. Does not touch Series Bible, Timeline, or journeys.
 * Generate-from-chats accepts through this same PUT.
 */
export const seriesSnapshotsApi = {
  get: (projectId) => api.get(`/projects/${projectId}/series-snapshots`),
  put: (projectId, store) => api.put(`/projects/${projectId}/series-snapshots`, store),
};
